import type { ThroughputType } from '../../../../../../store/strategy-store/strategy-store.type';

type ChartDataItem = {
  date: string;
  rawDate: string;
  [DataKey.CompletedRegular]: number | null;
  [DataKey.TotalRegular]: number | null;
  [DataKey.CompletedFuture]: number | null;
  [DataKey.TotalFuture]: number | null;
  isCurrentMonth: boolean;
  targetEndDate?: string;
};

type ChartData = ChartDataItem[];
enum DataKey {
  CompletedRegular = 'completedRegular',
  TotalRegular = 'totalRegular',
  CompletedFuture = 'completedFuture',
  TotalFuture = 'totalFuture',
}

type LegendItem = {
  dataKey: DataKey;
  throughputType: ThroughputType;
  color: string;
};

export { DataKey };
export type { ChartData, ChartDataItem, LegendItem };
